import {
    ENTREGACERTA_LIST,
    ENTREGACERTA_LIST_LOADING,
    ENTREGACERTA_LIST_EVENTOS,
    ENTREGACERTA_SAVE_LOADING
} from '../actions/ActionsTypes';


const INITIAL_STATE = {
    nunotalist: [],
    isNunotaLoading: false,
    isSavingLoading: false,
    eventoslist: []
}


export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case ENTREGACERTA_LIST:
            return { ...state, nunotalist: action.payload }

        case ENTREGACERTA_LIST_EVENTOS:
            return { ...state, eventoslist: action.payload }

        case ENTREGACERTA_LIST_LOADING:
            return { ...state, isNunotaLoading: action.payload }

        case ENTREGACERTA_SAVE_LOADING:
            return { ...state, isSavingLoading: action.payload }

        default:
            return state;
    }
}